import { makeAutoObservable } from 'mobx';

export default class TicketModel {
  ticketID;
  customerID;
  workflowID;
  status;
  model;
  repairType;
  repair;
  latestTask;
  technician;
  bill;
  quotes;
  problem;
  openQuote;
  device;
  deviceID;
  repairTypeID;
  deviceName; // legacy client-only field (kept for backwards compatibility)
  otherDevice;
  promo;
  timeSlot;

  constructor(data) {
    this.update(data);

    makeAutoObservable(this);
  }

  update(data) {
    this.ticketID = data.ticketID;
    this.customerID = data.customerID;
    this.workflowID = data.workflowID;
    this.status = data.status;
    this.model = data.model;
    this.repairType = data.repairType;
    this.repair = data.repair;
    this.latestTask = data.latestTask;
    this.technician = data.technician;
    this.bill = data.bill ?? false;
    this.quotes = data.quotes ?? false;
    this.problem = data.problem;
    this.openQuote = data.openQuote;
    this.device = data.device;
    // Store deviceID and repairTypeID if provided (they might be at top level or nested)
    // Handle case where device/repairType might be false instead of an object
    this.deviceID = data.deviceID ?? (data.device && typeof data.device === 'object' ? data.device.deviceID : undefined);
    this.repairTypeID = data.repairTypeID ?? (data.repairType && typeof data.repairType === 'object' ? data.repairType.repairTypeID : undefined);
    // Bespoke fields (server-side preferred)
    this.otherDevice = data.otherDevice ?? undefined;

    // Legacy: preserve older client-only field if present
    this.deviceName =
      data.deviceName ??
      this.otherDevice ??
      (data.device && typeof data.device === 'object' ? data.device.device : undefined);
    this.promo = data.promo;
    this.timeSlot = data.timeSlots && data.timeSlots.PICKUP;
  }

  setCustomerID(customerID) {
    this.customerID = customerID;
  }

  setAcceptedQuote(quoteID) {
    this.quotes.forEach((quote, index) => {
      if (quote.quoteID === quoteID) {
        this.quotes[index].accepted = true;
      } else {
        this.quotes[index].accepted = false;
      }
    });
  }

  setTimeSlot(slot) {
    this.timeSlot = slot;
  }

  get isPaid() {
    return this.bill && this.bill.paymentID;
  }
}
